import $ from 'jquery';
import { initPodsCarousels } from './carousel';
import themeEditor from './themeEditor';

const Pods = () => {
  if ($('[data-pods-carousel]').length === 0) { return; }
  
  initPodsCarousels();
  themeEditor();

  let previous_breakpoint = window.theme.breakpoints.current;

  $(window).on('breakpointChange', (e, breakpoint) => {
    if (breakpoint !== 'mobile' && previous_breakpoint !== 'mobile') {
      return;
    }
    
    initPodsCarousels();
    previous_breakpoint = breakpoint;
  });
};

export { Pods };